<template>
  <div class="SectionRequirementsRtb">
    <div class="body">
      <h4 class="title">
        {{ $t('title') }}
      </h4>
      <div class="content">
        <div v-for="(item, index) in items" :key="index" class="item">
          <Icon :name="item.icon" />
          <div class="text">
            <div class="label">
              {{ item.label }}
            </div> {{ item.text }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getters, mergeLabels } from './../../../utils'

export default {
  computed: {
    icons() {
      return [
        { icon: 'plug' },
        { icon: 'document-check' },
        { icon: 'document-check' },
      ]
    },
    items() {
      return mergeLabels(this.icons, this.$ta('items'))
    },
    ...getters(),
  },
}
</script>

<style lang="scss">
.SectionRequirementsRtb {
  // background-color: $grey-lighter;
  margin-top: 2rem;
  .body {
    padding: 2rem 0;
    .title {
      font-weight: bold;
    }
    .content {
      padding: 1rem 0;
      .item {
        align-items: center;
        display: flex;
        font-size: 1.2rem;
        line-height: 1.5;
        margin: 1rem 0;
        .Icon {
          font-size: 2rem;
        }
        .text {
          font-weight: bold;
          margin-left: 1rem;
          .label {
            display: inline-block;
            font-weight: bold;
          }
        }
        &.uncentered {
          align-items: normal;
        }
      }
      p {
        font-size: 1.5rem;
        margin-top: 2rem;
      }
    }
  }
}
</style>

<i18n>
{
  "pl": {
    "title": "SIG jest zainteresowany zakupem projektów, które do 3 grudnia 2020 roku uzyskają:",
    "items": [
      {
        "text": "Warunki przyłączenia do sieci"
      },
      {
        "text": "Pozwolenie na budowę"
      },
      {
        "text": "Zaświadczenie o dopuszczeniu do aukcji"
      }
    ]
  }
}
</i18n>
